import { render, staticRenderFns } from "./signupList.vue?vue&type=template&id=1351bd1d&scoped=true&"
import script from "./signupList.vue?vue&type=script&lang=js&"
export * from "./signupList.vue?vue&type=script&lang=js&"
import style0 from "./signupList.vue?vue&type=style&index=0&id=1351bd1d&prod&scoped=true&lang=css&"
import style1 from "./signupList.vue?vue&type=style&index=1&id=1351bd1d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1351bd1d",
  null
  
)

export default component.exports